module.exports = __webpack_public_path__ + "images/account_setups/icon-project-list-view-5bbbe6a6fd14ad7656e94f1b6f70bc35.png";